import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, FileText, Copyright, ArrowLeft, Info } from "lucide-react";

const ICONS = { privacy: ShieldCheck, terms: FileText, dmca: Copyright, about: Info };

// Standalone, fully public legal page — no auth, no AppShell. Used for /privacy, /terms
// and /dmca so search engines and logged-out visitors can read the full policy directly
// ("Public Legal Shield").
const LegalPageLayout = ({ topicKey, title, body }) => {
  const Icon = ICONS[topicKey] || ShieldCheck;
  return (
    <div className="min-h-screen" data-testid={`legal-page-${topicKey}`}>
      <header className="max-w-3xl mx-auto px-6 sm:px-10 pt-8 pb-4 flex items-center justify-between">
        <Link to="/" className="gifted-brand text-xl" data-testid="legal-page-brand-link">GIFTED</Link>
        <Link to="/" data-testid="legal-page-back-link"
          className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-1.5">
          <ArrowLeft className="w-3.5 h-3.5" /> Back to GIFTED
        </Link>
      </header>

      <main className="max-w-3xl mx-auto px-6 sm:px-10 py-10">
        <div className="surface rounded-[1.75rem] p-8 sm:p-10 animate-fade-up">
          <div className="flex items-center gap-2.5 mb-6">
            <div className="w-10 h-10 rounded-full flex items-center justify-center bg-primary/10 text-primary">
              <Icon className="w-5 h-5" />
            </div>
            <h1 className="font-serif text-3xl" data-testid="legal-page-title">{title}</h1>
          </div>
          <div className="space-y-4 text-sm text-muted-foreground leading-relaxed" data-testid="legal-page-body">
            {body.map((p, i) => <p key={i}>{p}</p>)}
          </div>
          <p className="text-[11px] text-muted-foreground/70 mt-8">Last updated: 2026 · GIFTED, The Relationship OS.</p>
        </div>
      </main>

      <footer className="max-w-3xl mx-auto px-6 sm:px-10 pb-10 text-center sm:text-left">
        <span className="text-[11px] text-muted-foreground/70">© {new Date().getFullYear()} GIFTED · The Relationship OS. Crafted with care.</span>
      </footer>
    </div>
  );
};

export default LegalPageLayout;
